import { render, staticRenderFns } from "./ui_demos.vue?vue&type=template&id=24653712&scoped=true&"
import script from "./ui_demos.vue?vue&type=script&lang=ts&"
export * from "./ui_demos.vue?vue&type=script&lang=ts&"
import style0 from "./ui_demos.vue?vue&type=style&index=0&id=24653712&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24653712",
  null
  
)

export default component.exports